export const Telefone = () => {
  return (
    <div className="m-4 flex flex-col items-center text-gray-600">
      <strong>Maria Silva Soares</strong>
      <p>558.658.474-85</p>

      <div className="m-4 flex flex-col items-center text-primary">
        <h4 className="font-extrabold">+(55) 11 93938 - 1750</h4>

        <p>São Paulo</p>
      </div>

      <div className="m-4 grid grid-cols-3 gap-4 text-center text-white">
        <div className="digito">1</div>
        <div className="digito">2</div>
        <div className="digito">3</div>
        <div className="digito">4</div>
        <div className="digito">5</div>
        <div className="digito">6</div>
        <div className="digito">7</div>
        <div className="digito">8</div>
        <div className="digito">9</div>
        <div className="digito">*</div>
        <div className="digito">0</div>
        <div className="digito">#</div>
      </div>
    </div>
  );
};
